export default "/images/83c01ed095393bddf5aea0016206b9bb.avif";